import React from 'react'
import ReactDOM from 'react-dom/client'
import { DashboardApp } from './components/DashboardApp'
import './index.css'

// Route: /me/:agentId
const path = window.location.pathname.replace(/\/+$/, '')
const meMatch = path.match(/^\/me\/([A-Za-z0-9_-]{1,32})$/)

function pickRoot() {
  if (meMatch) return <DashboardApp agentId={meMatch[1]} />
  // Fallback for direct root access (no agentId in path).
  return (
    <div style={{ padding: 32, fontFamily: 'sans-serif', color: '#71717a', textAlign: 'center' }}>
      <p>Please open the personal link you received to view your dashboard.</p>
    </div>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>{pickRoot()}</React.StrictMode>
)
